import Zoom from '../../../views/ganttView/chart/zoom';
import globalStore from '$$globalStore';
import MassSelect from '../../../views/ganttView/controllers/massSelect';
import Config from '../../../views/ganttView/config';
import constants from '$$helpers/constants';
import app from '$$app';
import TodayMarker from '../../../views/ganttView/chart/todayMarker';
import ganttViewModel from '$$ganttViewModel';
import ProjectCalendar from '../../../views/ganttView/controllers/projectCalendar';
import multiViewsProjects from '$$multiviewModel';
import routerHelper from '$$routerHelper';
import Tasks from '../../../views/ganttView/controllers/tasks';
import Filter from '../../../views/ganttView/controllers/filter';
import Baselines from '../../../views/ganttView/baselines';
import Columns from '../../../views/ganttView/grid/columns';
import Editors from '../../../views/ganttView/grid/editors';
import webixContextMenu from '../../../views/ganttView/grid/webixContextMenu';
import inlineEditors from '../../../views/ganttView/controllers/inlineEditors';
import KeyboardNavigation from '../../../views/ganttView/grid/keyboardNavigation';
import getZoomLevelsConfig from '../../../views/ganttView/chart/zoom/getZoomLevelsConfig';

export default instance => {
  // Events from Store
  const storeSubscription = globalStore.subscribe(async (mutation, state) => {
    if (mutation.payload?.fromGantt) {
      return;
    }

    if (mutation.type.includes('baselines/enableBaseline')) {
      return Baselines.buildBaseline(mutation.payload);
    }

    if (mutation.type.includes('baselines/disableBaseline')) {
      return Baselines.removeBaseline(mutation.payload.id);
    }

    if (mutation.type === 'headerView/setZoom') {
      const mode = constants.ZOOM.zoomValueToMode[mutation.payload];
      const projectConfig = ganttViewModel.getProjectConfig();

      instance.callEvent('closeWorkloadResourceRows');
      Zoom.setZoomLevel(mode);

      return ganttViewModel.checkParamsToUpdateAndUpdate({ key: 'durationData', value: { ...projectConfig.durationData, mode } });
    }

    if (mutation.type === 'headerView/setWorkloadZoom') {
      Zoom.setZoomLevel(constants.ZOOM.zoomValueToMode[mutation.payload]);
      instance.callEvent('onChangeWorkloadZoom', [mutation.payload]);

      return;
    }

    if (mutation.type.includes('headerView/setWorkloadViewMode')) {
      instance.callEvent('onChangeWorkloadViewMode', [mutation.payload]);
    }

    if (mutation.type.includes('headerView/setOverdueTasks')) {
      return Config.setConfigParameter('highlight_overdue', !!mutation.payload, true);
    }

    // if (mutation.type.includes('headerView/setHeight')) {
    //   setTimeout(() => {
    //     instance.render(); // adjust chart height
    //   }, 100);
    // }

    if (mutation.type.includes('headerView/setCriticalPath')) {
      return Config.setConfigParameter('highlight_critical_path', !!mutation.payload, true);
    }
    if (mutation.type.includes('headerView/setFloatTime')) {
      return Config.setConfigParameter('show_float_time', !!mutation.payload, true);
    }

    if (mutation.type.includes('massChange/setIsEnabled')) {
      return mutation.payload ? MassSelect.enable() : MassSelect.disable();
    }

    if (mutation.type.includes('massChange/removeSelectedItems')) {
      return MassSelect.removeSelectedTaskIds(mutation.payload.items);
    }

    if (mutation.type.includes('teamSetting/setCurrency')) {
      instance.render();
    }

    if (mutation.type.includes('filter/updateCurrentFilter')) {
      Filter.run();
    }

    if (mutation.type.includes('user/updateActivity')) {
      if (mutation.payload.activity?.name === 'timeTracker') {
        instance.refreshData();
      }
    }

    if (mutation.type.includes('resourcesModel/updateResourceOnProjects')) {
      instance.render();
    }
  });

  instance.attachEvent('onAfterTaskAdd', taskId => {
    app.trigger('createNewTask', taskId);
  });

  instance.attachEvent('onAfterLinkAdd', linkId => {
    app.trigger('createNewLink', linkId);
  });

  instance.attachEvent('onMassSelectStateChange', selectedState => {
    const selectedTasksIds = Object.entries(selectedState).reduce((result, [taskId, taskState]) => {
      if (taskState.isSelected) {
        result.push(Number(taskId));
      }

      return result;
    }, []);

    globalStore.commit('massChange/setSelectedItems', { items: selectedTasksIds, fromGantt: true });
  });

  instance.attachEvent('onTaskSelectFromContextMenu', taskId => {
    globalStore.commit('massChange/setIsEnabled', true);
    MassSelect.selectTask(taskId);
  });

  instance.attachEvent('checkParamsToUpdateAndUpdate', params => {
    ganttViewModel.checkParamsToUpdateAndUpdate(params);
  });

  instance.attachEvent('onUpdateUserNotificationSettings', options => {
    globalStore.dispatch('userNotification/updateUserSettings', options);
  });

  instance.attachEvent('onUpdateWindowParams', () => {
    globalStore.dispatch('updateWindowParams', {});
  });

  instance.attachEvent('setShowGrid', flag => {
    globalStore.commit('setShowGrid', flag);
  });

  instance.attachEvent('setZoom', zoom => {
    globalStore.commit('headerView/setZoom', zoom);
  });

  instance.attachEvent('setWorkloadZoom', zoom => {
    globalStore.commit('headerView/setWorkloadZoom', zoom);
  });

  instance.attachEvent('setWorkloadViewMode', viewMode => {
    globalStore.commit('headerView/setWorkloadViewMode', viewMode);
  });

  instance.attachEvent('setMassSelectEnabled', flag => {
    globalStore.commit('massChange/setIsEnabled', flag);
  });

  instance.attachEvent('onMultiviewProjectsOrderChange', order => {
    multiViewsProjects.updateOrderActiveMultiview(order);
  });

  instance.attachEvent('onAfterDeleteTasksFromStore', () => {
    Tasks.checkRemovingTask();
    inlineEditors.hide();
    KeyboardNavigation.creatingTask = false;
  });

  instance.attachEvent('onOpenTaskSettings', (taskId, initOption) => {
    const item = instance.isTaskExists(taskId) && instance.getTask(taskId);

    if (!item || item.type === instance.config.types.button || !item.parent || item.parent === 1) {
      return;
    }

    const taskViewPath = `${routerHelper.getCurrentRoute().path}/task/${taskId}`;
    const taskSettingsRoute = routerHelper.isTaskSettingsRoute();

    if (initOption) {
      window.taskSettingsData = {
        initOptions: {
          [initOption]: true,
        },
      };
    }

    if (!taskSettingsRoute) {
      routerHelper.changeRoute(taskViewPath);

      return;
    }

    routerHelper.pushRoute({
      name: taskSettingsRoute,
      params: {
        taskId: String(taskId),
      },
    });
  });

  instance.attachEvent('onOpenTaskProject', taskId => {
    const item = instance.isTaskExists(taskId) && instance.getTask(taskId);

    if (item && item.gantt_id) {
      routerHelper.pushRoute({
        name: 'project',
        params: {
          projectId: item.gantt_id,
          mode: 'gantt',
        },
      });
    }
  });

  instance.attachEvent('onShowUpgradePopup', options => {
    globalStore.commit('paymentClient/showUpgradePopup', options);
  });

  instance.attachEvent('onShowGlobalPopup', options => {
    globalStore.dispatch('globalPopup/show', options);
  });

  instance.attachEvent('onCloseGlobalPopup', () => {
    globalStore.dispatch('globalPopup/close');
  });

  const appSubscriptions = [];

  appSubscriptions.push(app.on('settings:estimationModes:change', value => {
    Config.setConfigParameter('estimation_mode', value);
  }));

  appSubscriptions.push(app.on('settings:applyResourceCalendar:change', value => {
    Config.setConfigParameter('apply_resource_calendar', !!value);
  }));

  appSubscriptions.push(app.on('settings:updateGanttSettings:change', () => {
    instance.callEvent('workloadClearAndParse');
  }));

  appSubscriptions.push(app.on('settings:autoScheduling:change', value => {
    Config.autoScheduling(value);
    instance.autoSchedule();
    instance.render();
  }));

  appSubscriptions.push(app.on('settings:autoBudget:change', value => {
    Config.setConfigParameter('auto_budget', value);
    instance.render();
  }));

  appSubscriptions.push(app.on('settings:progressType:change', value => {
    Config.setConfigParameter('progress', value);
  }));

  appSubscriptions.push(app.on('settings:resourceLoadingType:change', value => {
    Config.setConfigParameter('resource_loading_type', value, true);
  }));

  appSubscriptions.push(app.on('settings:durationView:change', value => {
    Config.setConfigParameter('duration_view', value, true);
  }));

  appSubscriptions.push(app.on('settings:skipOffTime:change', value => {
    if (instance.config.durationData.mode !== 'hour') {
      Config.setConfigParameter('skip_off_time', !value, true);
    }
  }));

  appSubscriptions.push(app.on('settings:advancedButtons:change', value => {
    Config.setConfigParameter('show_advanced_buttons', value, true);
  }));

  appSubscriptions.push(app.on('settings:currentDayMarker:change', value => {
    value ? TodayMarker.addMarker() : TodayMarker.removeMarker();
    Config.setConfigParameter('current_day_marker', value, false);
  }));

  appSubscriptions.push(app.on('settings:showResourceAvatar:change', value => {
    Config.setConfigParameter('show_resource_avatar', value, true);
  }));

  appSubscriptions.push(app.on('settings:discolorationTasks:change', value => {
    Config.setConfigParameter('discoloration_tasks', value, true);
  }));

  appSubscriptions.push(app.on('settings:crossOutTasks:change', value => {
    Config.setConfigParameter('cross_out_tasks', value, true);
  }));

  appSubscriptions.push(app.on('settings:rightSideText:change', value => {
    Config.setConfigParameter('right_side_text', value, true);
  }));

  appSubscriptions.push(app.on('settings:skin:change', value => {
    Config.setSkin(value);
  }));

  appSubscriptions.push(app.on('settings:viewMode:change', value => {
    Config.durationViewMode(value);
    instance.render();
  }));

  appSubscriptions.push(app.on('settings:displayDays:change', value => {
    Config.setConfigParameter('show_days_on_chart', value, true);
    Zoom.init(instance);
  }));

  appSubscriptions.push(app.on('ganttview:task:select', taskId => {
    Tasks.unselectTask();

    if (!routerHelper.isListViewRoute()) {
      Tasks.selectTask(+taskId);
    }

    instance.render();
  }));

  appSubscriptions.push(app.on('ganttview:task:unselect', () => {
    Tasks.unselectTask();
    instance.render();
  }));

  appSubscriptions.push(app.on('popup:show', () => {
    Tasks.unselectTask();
    instance.render();
  }));

  appSubscriptions.push(app.on('project-config:change', (projectId, projectConfig) => {
    Config.updateProjectConfig(projectId, projectConfig);
    instance.render();
  }));

  appSubscriptions.push(app.on('project-calendar:change', (ganttId, durationData = null) => {
    const projectId = ganttId || instance.config.gantt_id;
    const _durationData = durationData ?? ganttViewModel.getProjectConfig(projectId).durationData;

    ProjectCalendar.addOrUpdateCalendar(projectId, _durationData);
    instance.clearCache('isWorkDays');
    instance.render();
    if (instance.config.auto_scheduling.enabled) {
      instance.autoSchedule();
    }
  }));

  appSubscriptions.push(app.on('columnsBar:gantt:change', (columnId, value, options = {}) => {
    Columns.changeColumnCheckbox(columnId, value, options.isAdvanced);
    Editors.applyEditorsToColumns(instance);
    instance.render();
  }));

  appSubscriptions.push(app.on('userCustomColumnsModel:change', (projectId, action, columnId, isShow, fromList) => {
    Columns.changeUserCustomColumn(action, columnId, isShow);
    Editors.applyEditorsToColumns(instance);
    instance.render();
  }));

  appSubscriptions.push(app.on('ganttview:contextMenu:close', () => {
    webixContextMenu.hide();
  }));

  appSubscriptions.push(app.on('ganttview:editors:unload', () => {
    inlineEditors.hide();
  }));

  appSubscriptions.push(app.on('gantt:keyboard:enable', () => {
    KeyboardNavigation.toggleState(true);
  }));

  appSubscriptions.push(app.on('gantt:keyboard:disable', () => {
    KeyboardNavigation.toggleState(false);
  }));

  appSubscriptions.push(app.on('gantt:keyboard:unselect', () => {
    KeyboardNavigation.removeSelection();
  }));

  appSubscriptions.push(app.on('header:refresh:filter', () => {
    Filter.run();
  }));

  appSubscriptions.push(app.on('ganttview:render', () => {
    instance.render();
  }));

  return {
    storeSubscription,
    appSubscriptions,
  };
};
